/**
 * File mobile-menu.js.
 *
 *
 *
 * Contains scripts to make mobile menu work smoothly
 */

(function ($) {
    // Add classname to the body tag to make the mobile menu full width/height on toggle
    $(document).ready(function () {
        $(".menu-toggle").click(function (e) {
            var toggled_value = $("#mobile-nav").attr("aria-expanded");
            if (toggled_value == "true") {
                $("body").addClass("fixedPosition");
                $(".menu-toggle").addClass("fixedPosition");
                $(".widget").addClass("fixedPosition");
            } else {
                $("body").removeClass("fixedPosition");
                $(".menu-toggle").removeClass("fixedPosition");
                $(".widget").removeClass("fixedPosition");
            }
        });
        // add fixed position to nav when scroll
        var scrollTop = 0;
        $(window).scroll(function () {
            scrollTop = $(window).scrollTop();
            $(".counter").html(scrollTop);

            if (scrollTop >= 100) {
                $("#masthead").addClass("fixed-menu");
                $(".site-content").addClass("body-padding");
            } else if (scrollTop < 10) {
                $("#masthead").removeClass("fixed-menu");
                $(".site-content").removeClass("body-padding");
            }
        });
    });
})(jQuery);